import { isVue3 as I, inject as w, isVue2 as S, Vue2 as b, ref as c, watch as x, onMounted as P, onUnmounted as G, nextTick as B, defineComponent as k, toRef as V, h as y } from "vue-demi";
const C = Symbol("stripe"), E = Symbol("stripe-style"), R = {
  theme: "flat",
  variables: {
    borderRadius: "5px",
    colorText: "#ddd",
    colorBackground: "none",
    fontSizeBase: "16px",
    focusOutline: "none",
    colorPrimary: "#50fcea",
    fontFamily: '"Source Sans Pro", system-ui, sans-serif',
    spacingUnit: ".5rem",
    colorDanger: "#ff3954",
    colorDangerText: "#ff3954",
    focusBoxShadow: "none"
  },
  rules: {
    ".Input": {
      padding: ".25rem 0",
      backgroundColor: "transparent",
      borderBottom: "1px solid #99b5d0",
      borderRadius: "0"
    },
    ".Input::placeholder": {
      color: "#99b5d0"
    },
    ".Input--invalid": {
      color: "#ddd",
      boxShadow: "none",
      borderBottomColor: "#ff3954"
    },
    ".Tab": {
      backgroundColor: "#262f37",
      border: "2px solid transparent",
      transition: "border-color .2s ease"
    },
    ".Tab--selected": {
      borderColor: "#50fcea"
    },
    ".Label": {
      fontWeight: "bold",
      fontSize: ".875rem",
      marginBottom: "0",
      lineHeight: "1.25rem"
    }
  }
}, D = [
  {
    family: "Source Sans Pro",
    src: "url(https://cdn.g-portal.cloud/fonts/SourceSansPro-Regular.woff)",
    weight: "400"
  },
  {
    family: "Source Sans Pro",
    src: "url(https://cdn.g-portal.cloud/fonts/SourceSansPro-Black.woff)",
    weight: "800"
  }
], $ = (e, {
  elementId: a,
  onIsValidChange: s = () => {
  },
  onError: o = () => {
  },
  locale: i = "en",
  showTerms: u = !1
}) => {
  let r, t;
  if (I ? (r = w(C), t = w(E)) : S && (r = b.prototype.$stripe, t = b.prototype.$stripeConfig), r == null || t == null || t.publicKey == null || t.publicKey.length === 0)
    return console.warn("Stripe instance and/or StripeConfig not provided. Did you added the plugin and configured properly?"), {};
  const d = c(), l = c(), f = c(!1), g = c(""), h = async () => {
    var n, p, v;
    if (r == null || t == null || t.publicKey == null || t.publicKey.length === 0) {
      console.warn(
        "Stripe instance and/or StripeConfig not provided. Did you added the plugin and configured properly?"
      );
      return;
    }
    if (e.value == null || e.value.length === 0) {
      console.warn("Client secret not provided. Please mount the component with client secret as prop.");
      return;
    }
    try {
      d.value = (n = r.value) == null ? void 0 : n.elements({
        clientSecret: e.value,
        fonts: t.fonts,
        appearance: t.appearance,
        locale: i
      }), l.value = d.value.create("payment", {
        terms: {
          card: u ? "always" : "never"
        }
      }), (p = l.value) == null || p.on("change", (m) => {
        s(m.complete);
      }), f.value = !1, await B(), (v = l.value) == null || v.mount(`#${a}`);
    } catch (m) {
      g.value = m.message, f.value = !0, o(m);
    }
  }, T = async () => {
    if (r == null || d.value == null) return;
    const n = await d.value.submit();
    if (n.error != null)
      throw new Error(n.error.message);
    const p = await r.value.confirmSetup({
      elements: d.value,
      redirect: "if_required"
    });
    if (p.error != null)
      throw new Error(p.error.message);
    return { setupIntent: p.setupIntent };
  };
  return x(
    () => e.value,
    () => {
      e.value !== "" && h();
    }
  ), P(async () => {
    try {
      const { loadStripe: n } = await import("@stripe/stripe-js");
      if (r == null || t == null) {
        console.error("Stripe instance and/or StripeConfig not provided. Did you added the plugin?");
        return;
      }
      r.value == null && (r.value = await n(t.publicKey), h());
    } catch (n) {
      g.value = n.message, f.value = !0, o(n);
    }
  }), G(() => {
    l.value != null && (l.value.unmount(), l.value.destroy());
  }), {
    paymentElement: l,
    hasInitError: f,
    initError: g,
    submit: T,
    initStripe: h
  };
}, j = k({
  name: "GpStripePayment",
  emits: ["update:isValid"],
  props: {
    /**
     * The id of the element. The target, where the stripe element will be mounted.
     */
    mountTargetId: {
      type: String,
      required: !0
    },
    /**
     * The client secret of the payment intent coming from the server.
     */
    clientSecret: {
      type: String,
      required: !0
    },
    /**
     * Determines if the stripe payment form is valid.
     */
    isValid: {
      type: Boolean,
      default: !1
    },
    /**
     * Determines if the terms should be shown.
     */
    showTerms: {
      type: Boolean,
      default: !1
    },
    /**
     * The locale of the stripe payment form.
     */
    locale: {
      type: String,
      default: "en"
    }
  },
  setup(e, { emit: a }) {
    const s = V(e, "clientSecret"), { submit: o, hasInitError: i, initError: u } = $(s, {
      onIsValidChange: (r) => a("update:isValid", r),
      elementId: e.mountTargetId,
      locale: e.locale,
      showTerms: e.showTerms
    });
    return {
      submit: o,
      hasInitError: i,
      initError: u
    };
  },
  render() {
    return y("div", [
      y(
        "div",
        S ? { ref: "stripeWrapper", attrs: { id: this.mountTargetId } } : { ref: "stripeWrapper", id: this.mountTargetId }
      ),
      this.hasInitError && this.initError != null && this.initError.length > 0 ? y("p", this.initError) : null
    ]);
  }
}), q = {
  install: (e, { appearance: a = R, fonts: s = D, publicKey: o, failSilently: i = !1 }) => {
    i && console.warn("[GpStripe]: failSilently is enabled. Errors will be suppressed. Use this only for test environments.");
    const u = c();
    if (S ? (e.prototype.$stripe = u, e.prototype.$stripeConfig = { appearance: a, fonts: s, publicKey: o }) : I && (e.provide(C, u), e.provide(E, { appearance: a, fonts: s, publicKey: o, failSilently: i })), o == null || o === "")
      if (i) {
        console.warn("[GpStripe]: Stripe public key is missing. Payment processing will not work.");
        return;
      } else
        throw new Error("[GpStripe]: Stripe public key is missing");
  }
};
export {
  R as GpStripeAppearance,
  E as GpStripeConfigInjectKey,
  D as GpStripeFonts,
  C as GpStripeInjectKey,
  j as GpStripePayment,
  q as default,
  $ as useGpStripePayment
};
